import angular from 'angular';
import template from './form.html';
import FormController from './form.controller.js';


const FormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: FormController,
    controllerAs: 'vm',
    bindings: {
        model: '<',
        onSubmit: '&',
        onCancel: '&'
    }

};

export default FormComponent;



// WEBPACK FOOTER //
// ./app/components/tip/form/form.js